import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class FinancialItemEventQueryCriteriaClass extends BaseCriteriaModel {
  local_created_time_from?: Optional<string> = Optional.empty();
  local_created_time_to?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();
  app_id?: Optional<string> = Optional.empty();
  hdr_guid?: Optional<string> = Optional.empty();

}

export class FinancialItemEventCriteriaModelQuery {
  query = '';

  constructor(financialItemEventCriteriaModel: FinancialItemEventQueryCriteriaClass) {

    if (!financialItemEventCriteriaModel) {
      return;
    }

    this.query += financialItemEventCriteriaModel.local_created_time_from.filter(x => x !== '').map(x => '&local_created_time_from=' + x).orElse('');
    this.query += financialItemEventCriteriaModel.local_created_time_to.filter(x => x !== '').map(x => '&local_created_time_to=' + x).orElse('');
    this.query += financialItemEventCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += financialItemEventCriteriaModel.app_id.filter(x => x !== '').map(x => '&app_id=' + x).orElse('');
    this.query += financialItemEventCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');

    this.query += '&status=' + financialItemEventCriteriaModel.status;
    this.query += '&orderBy=' + financialItemEventCriteriaModel.orderBy;
    this.query += '&order=' + financialItemEventCriteriaModel.order;
    this.query += '&offset=' + financialItemEventCriteriaModel.offset + '&limit=' + financialItemEventCriteriaModel.limit;
  }
}
